export const brandConfigObjectMap = new Map();

export const Brands = {
    MtnSouthAfricaEnglish: 'wp-za-en',
    MTNWorldPlaySouthAfricaEnglish: 'mtn-wp-za-en',
    WorldPlaySouthAfricaEnglish: 'wp-za-en',
};

brandConfigObjectMap.set(Brands.MtnSouthAfricaEnglish, {
    gameTitle: 'League XI',
    freePlayServiceId: 'football-free',
    baseRoute: '/home',
    productId: 310,
    serviceName: 'League XI-ZA MTN',
});

brandConfigObjectMap.set(Brands.MTNWorldPlaySouthAfricaEnglish, {
    gameTitle: 'League XI',
    freePlayServiceId: 'football-free',
    baseRoute: '/home',
    productId: 310,
    serviceName: 'League XI-ZA MTN',
});

brandConfigObjectMap.set(Brands.WorldPlaySouthAfricaEnglish, {
    gameTitle: 'League XI',
    freePlayServiceId: 'football-free',
    baseRoute: '/home',
    productId: 310,
    serviceName: 'League XI-ZA MTN',
});
